import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom'
import { ReadingPictureList } from './ReadingPictureList';

export const ReadingPictureView = ()=>{
    const { school, id } = useParams();

    return (
        <div className="activity_list _picture bdT0">
            <div className="inner">
                <ReadingPictureList path={`/${school}/picture`} forcedData={{isbn:null, user:null, type:'picture', id}} />
                <div className="alignC pdT20">
                    <Link className="btn _blue" to={`/${school}/picture`}>
                        독서화 목록
                    </Link>
                </div>
            </div>
        </div>
    );
}